let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("bXKJJ")).then(() => parcelRequire('3qmlA'));